import { Text, Tooltip } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import { useMatchMedia } from 'services/media-matcher';
import { FeatureItem } from '../../feature-item/feature-item';
import { PricingTable } from './pricing-table';
import css from '../comparison-table.module.css';
function EssentialsTable() {
  const {
    t
  } = useTranslation('pricing_v2_3');
  const isDesktop = useMatchMedia('(min-width: 960px)');
  return <PricingTable caption={t('comparison.sections.essentials')} headerRow={<PricingTable.HeaderRow>
                    <PricingTable.HeaderCell title={t('comparison.plans.beginner.name')} description={t('comparison.plans.beginner.description')} size="xs" />
                    <PricingTable.HeaderCell title={t('comparison.plans.pro.name')} description={t('comparison.plans.pro.description')} size="xs" />
                    <PricingTable.HeaderCell title={t('comparison.plans.teams.name')} description={t('comparison.plans.teams.description')} size="xs" />
                </PricingTable.HeaderRow>} tableBody={<PricingTable.Body>
                    <PricingTable.BodyRow hoverable={true} tableHeader={<FeatureItem name={t('comparison.items.activeProjects.name')} description={t('comparison.items.activeProjects.description')} toggleVisible={isDesktop} />}>
                        <PricingTable.BodyCell data={5} />
                        <PricingTable.BodyCell data={300} />
                        <PricingTable.BodyCell data={<Text size="body-xs" weight="medium" tag="span">
                                    <Tooltip title={t('comparison.items.activeProjects.businessTooltip')}>
                                        {t('comparison.common.nForEachMember', {
            count: 300
          })}
                                        &nbsp;<span className={css.colorSecondary}>*</span>
                                    </Tooltip>
                                </Text>} />
                    </PricingTable.BodyRow>
                    <PricingTable.BodyRow hoverable={true} tableHeader={<FeatureItem name={t('comparison.items.dueDatesAndTimes.name')} description={t('comparison.items.dueDatesAndTimes.description')} toggleVisible={isDesktop} />}>
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={true} />
                    </PricingTable.BodyRow>
                    <PricingTable.BodyRow hoverable={true} tableHeader={<FeatureItem name={t('comparison.items.priorityLevels.name')} description={t('comparison.items.priorityLevels.description')} toggleVisible={isDesktop} />}>
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={true} />
                    </PricingTable.BodyRow>
                    <PricingTable.BodyRow hoverable={true} tableHeader={<FeatureItem name={t('comparison.items.subTasks.name')} description={t('comparison.items.subTasks.description')} toggleVisible={isDesktop} />}>
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={true} />
                    </PricingTable.BodyRow>
                    <PricingTable.BodyRow hoverable={true} tableHeader={<FeatureItem name={t('comparison.items.reminders.name')} description={t('comparison.items.reminders.description')} toggleVisible={isDesktop} />}>
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={true} />
                        <PricingTable.BodyCell data={true} />
                    </PricingTable.BodyRow>
                    <PricingTable.BodyRow hoverable={true} tableHeader={<FeatureItem name={t('comparison.items.fileUploads.name')} description={t('comparison.items.fileUploads.description')} toggleVisible={isDesktop} />}>
                        <PricingTable.BodyCell data={t('comparison.common.mb', {
        count: 5
      })} />
                        <PricingTable.BodyCell data={t('comparison.common.mb', {
        count: 100
      })} />
                        <PricingTable.BodyCell data={t('comparison.common.mb', {
        count: 100
      })} />
                    </PricingTable.BodyRow>
                </PricingTable.Body>} data-sentry-element="PricingTable" data-sentry-component="EssentialsTable" data-sentry-source-file="essentials-table.tsx" />;
}
export { EssentialsTable };